// ===================================================================
// KAIXO - Latido Dorado · Animación al reclamar
// ===================================================================
// Muestra una medalla gigante (oro o plata), confeti y mensaje durante
// 2.5 segundos. Se invoca tras un claim exitoso.
// ===================================================================

import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import './LatidoDorado.css';

function LatidoDoradoAnimation({ kind, rank, onDone }) {
    // Auto-ocultar a los 2.5s
    React.useEffect(() => {
        const t = setTimeout(() => onDone?.(), 2500);
        return () => clearTimeout(t);
    }, [onDone]);

    // Confeti: 20 partículas con trayectoria aleatoria
    const confetti = useMemo(() => {
        const colors = kind === 'gold'
            ? ['#D4AF37', '#F4D875', '#FFD700', '#FFF3B8']
            : ['#B8B8B8', '#E0E0E0', '#C0C0C0', '#F0F0F0'];
        return Array.from({ length: 20 }, (_, i) => {
            const angle = Math.random() * Math.PI * 2;
            const dist = 150 + Math.random() * 250;
            const dx = Math.cos(angle) * dist;
            const dy = Math.sin(angle) * dist + 100;
            const color = colors[i % colors.length];
            const delay = Math.random() * 0.3;
            return { dx, dy, color, delay, id: i };
        });
    }, [kind]);

    const medal = kind === 'gold' ? '🥇' : '🥈';
    const text = kind === 'gold'
        ? '¡Latido Dorado conseguido!'
        : '¡Latido Plata conseguido!';
    const subtext = rank ? `Eres el nº ${rank}` : '';

    return ReactDOM.createPortal(
        <div className="ld-animation-overlay">
            {confetti.map(c => (
                <div
                    key={c.id}
                    className="ld-confetti"
                    style={{
                        background: c.color,
                        '--ld-dx': `${c.dx}px`,
                        '--ld-dy': `${c.dy}px`,
                        animationDelay: `${c.delay}s`
                    }}
                />
            ))}
            <div className="ld-animation-medal">{medal}</div>
            <div className="ld-animation-text">
                {text}{subtext ? ` · ${subtext}` : ''}
            </div>
        </div>,
        document.body
    );
}

export default LatidoDoradoAnimation;
